import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { userOnPaytmMembershipPlanBackend } from './user-on-paytm-membership-plan.backend';
import { userOnPaytmMembershipPlanReducer } from './user-on-paytm-membership-plan.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'userOnPaytmMembershipPlan',
      userOnPaytmMembershipPlanReducer,
    ),
    BackendModule.forFeature(
      'userOnPaytmMembershipPlan',
      userOnPaytmMembershipPlanBackend,
    ),
  ],
})
export class DatastoreUserOnPaytmMembershipPlanModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/user-on-paytm-membership-plan/user-on-paytm-membership-plan.module.ts